export const dotLoaderCss = {
  container: {
    margin: '60px',
  },
};
